import {
  ChannelTypeInternal,
  GenericInputChannelStateResponse,
  GenericInputTypeInternal,
  UserChannel,
} from '../../../../../data-access/gql-types/graphql';
import { ChannelIconTypeEnum } from '../../../../../types';
import { ChannelType } from '../../../types';
import { ChannelGenericInputStateType } from '../../../types/channel/generic-input';

export const parseGenericInput = (userChannel: UserChannel): ChannelType => {
  const channelPayload = userChannel.payload as GenericInputChannelStateResponse | undefined;

  return {
    id: userChannel.id,
    installationId: userChannel.installationId,
    isVisible: userChannel.isVisible,
    alias: userChannel.alias,
    iconName: userChannel.iconName || ChannelIconTypeEnum.ICON_VERTICAL_GATE,
    deviceId: userChannel.deviceId,
    currentFirmwareVersion: userChannel.currentFirmwareVersion || null,
    data: {
      type: ChannelTypeInternal.GenericInput,
      groupType: ChannelTypeInternal.GenericInput,
      genericInputType: channelPayload?.genericInputType || GenericInputTypeInternal.Unknown,
      monostableMode: channelPayload?.monostableMode || undefined,
      bistableMode: channelPayload?.bistableMode || undefined,
    },
  };
};

export const parseGenericInputStateChannel = (userChannel: UserChannel): ChannelGenericInputStateType => ({
  deviceConnectionState: userChannel.payload?.deviceConnectionState,
  status: null,
});
